import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updatePaymentMethod, getUserProfile } from "../../api/user";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const UpdatePaymentMethodForm = ({ onClose }) => {
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsProcessing(true);

        try {
            // Create payment method with Stripe
            const cardElement = elements.getElement(CardElement);
            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: "card",
                card: cardElement,
            });

            if (error) {
                toast.error(error.message);
                setIsProcessing(false);
                return;
            }

            // Call backend API to update payment method
            await dispatch(updatePaymentMethod(paymentMethod.id))
                .then((res) => {
                    toast.success("Payment method updated successfully!");
                    // Refresh user profile to get updated data
                    dispatch(getUserProfile());
                    setIsProcessing(false);
                    onClose();
                })
                .catch((err) => {
                    toast.error(err.message || "Failed to update payment method");
                    setIsProcessing(false);
                });
        } catch (error) {
            toast.error(error.message || "An error occurred");
            setIsProcessing(false);
        }
    };

    const cardElementOptions = {
        style: {
            base: {
                fontSize: "16px",
                color: "#fff",
                backgroundColor: "#1a1a1a",
                "::placeholder": {
                    color: "#aab7c4",
                },
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        },
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3 p-3" style={{ backgroundColor: "#1a1a1a", borderRadius: "5px" }}>
                <CardElement options={cardElementOptions} />
            </div>
            <div className="d-flex justify-content-end gap-2">
                <Button variant="secondary" onClick={onClose} disabled={isProcessing}>
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    type="submit"
                    disabled={!stripe || isProcessing}
                >
                    {isProcessing ? "Processing..." : "Update Payment Method"}
                </Button>
            </div>
        </form>
    );
};

const UpdatePaymentMethodModal = (props) => {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="update-payment-modal"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton style={{ backgroundColor: "#111", borderBottom: "1px solid #333" }}>
                <Modal.Title style={{ color: "#fff" }}>Update Payment Method</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#111", color: "#fff" }}>
                <p className="mb-3 text-secondary">
                    Update your payment method for your premium subscription. Your new card will be charged for future billing cycles.
                </p>
                <Elements stripe={stripePromise}>
                    <UpdatePaymentMethodForm onClose={props.onHide} />
                </Elements>
            </Modal.Body>
        </Modal>
    );
};

export default UpdatePaymentMethodModal;
